import { render, staticRenderFns } from "./MenuPage.vue?vue&type=template&id=e8b0c2e8&scoped=true"
import script from "./MenuPage.vue?vue&type=script&lang=ts"
export * from "./MenuPage.vue?vue&type=script&lang=ts"
import style0 from "./MenuPage.vue?vue&type=style&index=0&id=e8b0c2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b0c2e8",
  null
  
)

export default component.exports